const currency = (money) => {
  if (!money) return '$0'
  return money.toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP'
  })
}

export default {
  currency
}
